import SentEmailConfirmation from './SentEmailConfirmation';

export default SentEmailConfirmation;
